import { permissionsService } from '../services/permissionsService';

/**
 * QUEM VÊ OS RECEBIMENTOS DE UM COMPROMISSO — um lugar só.
 *
 * A aba do modal de compromisso e a caixa do modal de gestão só apareciam para
 * a conta marcada como "Versão 1 (Avançada)". A franqueada de Itajaí abria a
 * tela Compromissos pagos e não pagos, via quanto faltava receber e não tinha
 * como ver os recebimentos do compromisso (chamados 2026-0059 e 2026-0060).
 *
 * Quem enxerga o financeiro enxerga os recebimentos: os mesmos grupos da rota
 * /finance/compromissos-pagos-nao-pagos. A conta em Versão 1 continua vendo,
 * seja qual for o grupo — ninguém perde o que já tinha.
 */
const GRUPOS_QUE_VEEM_O_FINANCEIRO = ['Full', 'Franqueado', 'Gerente'];

export function veOsRecebimentosDoCompromisso(usuarioVersao: number | string = 0): boolean {
  const versao = Number(usuarioVersao) || Number(permissionsService.getUser()?.versaoSistema) || 0;
  return versao === 1 || permissionsService.isUserInGroups(GRUPOS_QUE_VEEM_O_FINANCEIRO);
}
